<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 5.69895H2.25V4.93641L18.75 3.59433V4.93641H21V2.64878C21 0.97118 19.6635 -0.206188 18.0315 0.0302009L2.97 2.21718C1.3365 2.45509 0 4.02135 0 5.69895V20.9498C0 21.7588 0.31607 22.5346 0.87868 23.1066C1.44129 23.6786 2.20435 24 3 24H21C21.7956 24 22.5587 23.6786 23.1213 23.1066C23.6839 22.5346 24 21.7588 24 20.9498V8.74913C24 7.94017 23.6839 7.16434 23.1213 6.59233C22.5587 6.02031 21.7956 5.69895 21 5.69895Z"
      fill="#80B7FF"
    />
    <path
      d="M12 11L12 19"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M12 11L16 15"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M12 11L8 15"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: [Number, String], default: 24 },
    height: { type: [Number, String], default: 24 },
    color: { type: String, default: "#D3D4DE" },
  },
};
</script>
